import {createContext} from 'react';

export const Theme = createContext('euro');
